import React from 'react';
import { Field } from 'react-final-form';
import css from './UrlInputField.module.css';

const UrlInputField = ({ label, fieldName = 'linkedinProfileUrl', placeholder }) => {
  const validateUrl = value => {
    if (!value) return 'Required';
    try {
      new URL(value);
      return undefined; // valid
    } catch {
      return 'Please enter a valid URL (e.g. https://linkedin.com/in/username)';
    }
  };

  return (
    <Field name={fieldName} validate={validateUrl}>
      {({ input, meta }) => (
        <div className={css.root}>
          <label className={css.label}>{label}</label>
          <input
            {...input}
            type="url"
            placeholder={placeholder || 'https://www.linkedin.com/in/yourname'}
            className={`${css.input} ${meta.touched && meta.error ? css.error : ''} ${
              meta.touched && !meta.error ? css.valid : ''
            }`}
          />
          {meta.touched && meta.error && <span className={css.errorMessage}>{meta.error}</span>}
          {meta.touched && !meta.error && <span className={css.successMessage}>Looks good!</span>}
        </div>
      )}
    </Field>
  );
};

export default UrlInputField;
